import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    smooth: { type: Boolean, default: true }
  }

  connect() {
    this.observer = new MutationObserver(() => {
      // Debounce the scroll
      clearTimeout(this.scrollTimeout)
      this.scrollTimeout = setTimeout(() => {
        this.scrollToBottom()
      }, 100)
    })

    this.observer.observe(this.element, {
      childList: true,
      subtree: false
    })
  }

  disconnect() {
    this.observer.disconnect()
    clearTimeout(this.scrollTimeout)
  }

  scrollToBottom() {
    this.element.closest('[data-scroll-container]').scrollTo({
      top: this.element.scrollHeight,
      behavior: this.smoothValue ? 'smooth' : 'auto'
    })
  }
}